export const STATE_ACCEPTED = 'accepted'
export const STATE_APPLIED = 'applied'
export const STATE_ARCHIVED = 'archived'
export const STATE_CLOSED = 'closed'
export const STATE_CONFLICTED = 'conflicted'
export const STATE_DELETED = 'deleted'
export const STATE_FROZEN = 'frozen'
export const STATE_OPEN = 'open'
export const STATE_PRIVATE = 'private'
export const STATE_PROPOSED = 'proposed'
export const STATE_PUBLIC = 'public'
export const STATE_REJECTED = 'rejected'
export const STATE_RESOLVED = 'resolved'
export const STATE_PENDING = 'pending'

export const TYPE_COMMENT = 'comment'
export const TYPE_DIAGRAM = 'diagram'
export const TYPE_PROBLEM = 'question'
export const TYPE_REPORT = 'claim'
export const TYPE_RESOURCE = 'resource'
export const TYPE_SUGGESTION = 'suggestedChange'

export const PART_CURRENT = 'current'
export const PART_MINE = 'mine'
export const PART_OTHERS = 'others'

export const PROP_CHILDREN_COUNT = 'childrenCount'
export const PROP_PUBLISHED_CHILDREN_COUNT = 'publishedChildrenCount'

export const AGG_KEY = 'scoreAggregates'
export const DEFAULT_AGG_INDEX = 0 // index for mean default aggregate

export const TYPE_TO_PARENT_RELATION = {
  claim: 'hypothesis',
  comment: 'comment',
  diagram: 'description',
  resource: 'hypothesis',
  suggestedChange: 'suggestedChange'
}

export const USER_GROUP_CODE = {
  ADMIN: 'ADMIN'
}
export const USER_PERM_CODE = {
  ADD_PROBLEM: 'ADD_QUESTION'
}

export const STATES = [
  {
    label: 'Frozen',
    value: STATE_FROZEN
  },
  {
    label: 'Open',
    value: STATE_OPEN
  },
  {
    label: 'Closed',
    value: STATE_CLOSED
  }
]

export const EXT_STATES = [
  {
    label: 'Pending',
    value: STATE_PENDING
  },
  {
    label: 'Deleted',
    value: STATE_DELETED
  }
]
